var map = {
	"./dots1.png": 80,
	"./dots2.png": 81,
	"./dots3.png": 82,
	"./dots4.png": 83,
	"./dots5.png": 84,
	"./dots6.png": 85,
	"./dots7.png": 86,
	"./dots8.png": 87,
	"./dots9.png": 88
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;